import TOutletContext from "@/cms/types/TOutletContext";
import EContentMetricsType from "@/core/enums/EContentMetricsType";
import useContentMetrics from "@/hooks/useContentMetrics";
import { isEmpty } from "lodash";
import { useOutletContext } from "react-router-dom";


type TContentMetricsIcon = {

    className?:string;
    itemClassName?:string;

}

const ContentMetricsIcon = ( props:TContentMetricsIcon ) => {
    const { contentId } = useOutletContext<TOutletContext>();

    const unqKey = `${contentId.split("-")[4]}CM`;
    const contentMetrics = useContentMetrics({ unqKey, contentId: contentId });

    if ( !contentMetrics || isEmpty(contentMetrics) ) return null;

    return contentMetrics.map((item) => {
        if ( item.metricType === EContentMetricsType.VIEW ) {
            return <li className={props.itemClassName}><i className="fa-solid fa-eye" /> {item.count}</li>
        }
        else if ( item.metricType === EContentMetricsType.LIKE ) {
            return <li className={props.itemClassName}><i className="fa-solid fa-thumbs-up" /> {item.count}</li>
        } 
        else if ( item.metricType === EContentMetricsType.DOWNLOAD ) {
            return <li className={props.itemClassName}><i className="fa-solid fa-download" /> {item.count}</li>
        }
        else if ( item.metricType === EContentMetricsType.COPY_PATH ) {
            return <li className={props.itemClassName}><i className="fa-solid fa-link" /> {item.count}</li>
        }
        return null;
    })
}

export default ContentMetricsIcon;